export const KEY_ESCAPE = { key: "Escape" };

export const KEY_ALT = { altKey: true };

export const KEY_CTLR = { ctrlKey: true };

export const KEY_SHIFT = { shiftKey: true };

export const isKeyMatch = (keyPattern, event) =>
	Object.entries(keyPattern).every(([field, value]) => event[field] === value);

export const comb = (...keys) => Object.assign({}, ...keys);
